export default __webpack_public_path__ + "static/media/Armguards of the Painlegion.dd8e4be9.jpg";